export function isSameAddress(a, b) {
  return a && b && a.toLowerCase() === b.toLowerCase()
}
